import _ from 'lodash'
import moment from 'moment'

/**
 * Constructs a hash of "months of the year" (see #14025 #14026)
 * e.g. { 'january': 'January', ... }
 */

const keys = [ 'january', 'february', 'march', 'april', 'may', 'june',
	'july', 'august', 'september', 'october', 'november', 'december']
const orderKeysFiscally = function() {
	const start = keys.indexOf('october')
	return [...keys.slice(start), ...keys.slice(0, start)]
}
const m = moment()
const monthsOfTheYear = _.transform(keys, (result, month, index) => {
	m.set('month', index)
	result[month] = m.format('MMMM')
}, {})

const keysInFiscalOrder = orderKeysFiscally()
// we have to return a function because if we just returned the days by
// themselves, iterating over them would return the file path as one of the
// properties (i.e. __fileName__: scripts/scoreboard/components/months-of-the-year.js)
export default () => monthsOfTheYear
export { keys }
export { keysInFiscalOrder }
